import { render, staticRenderFns } from "./loggers.vue?vue&type=template&id=fa671a2c&"
import script from "./loggers.vue?vue&type=script&lang=ts&"
export * from "./loggers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports